import React from "react"
import { IntlShape } from "react-intl"

export const addText = (text: string, intl: IntlShape) => {
	return React.createElement(
		"span",
		{ className: "description" },
		intl.formatMessage(
			{ id: text },
			{
				b: (str) => React.createElement("b", null, str),
			}
		)
	)
}

export const addTitle = (text: string, intl: IntlShape) => {
	return React.createElement(
		"h1",
		{ className: "heading" },
		intl.formatMessage({ id: text })
	)
}

export const addTextWithBulletPoint = (text: string, intl: IntlShape) => {
	return React.createElement(
		"span",
		null,
		React.createElement(
			"ul",
			{ className: "list-format description" },
			React.createElement(
				"li",
				null,
				intl.formatMessage(
					{ id: text },
					{
						b: (str) => React.createElement("b", null, str),
					}
				)
			)
		)
	)
}
